export const ADD_RATERS_TYPE = "ADD_RATERS_TYPE"
export const EDIT_RATERS_TYPE = "EDIT_RATERS_TYPE"
export const LIST_RATERS_TYPE = "LIST_RATERS_TYPE"
export const VIEW_RATERS_TYPE = "VIEW_RATERS_TYPE"
export const DELETE_RATERS_TYPE = "DELETE_RATERS_TYPE"

// Text
export const ADD_RATERS_TYPE_TEXT = "ADD_RATERS_TYPE_TEXT"
export const EDIT_RATERS_TYPE_TEXT = "EDIT_RATERS_TYPE_TEXT"
export const LIST_RATERS_TYPE_TEXT = "LIST_RATERS_TYPE_TEXT"
export const VIEW_RATERS_TYPE_TEXT = "VIEW_RATERS_TYPE_TEXT"
export const DELETE_RATERS_TYPE_TEXT = "DELETE_RATERS_TYPE_TEXT"

export const RATERS_TYPE_SUCCESS = "RATERS_TYPE_SUCCESS"
export const RATERS_TYPE_ERROR = "RATERS_TYPE_ERROR"

